/* eslint-disable react/jsx-props-no-spreading -- wrappers here forward props wholesale */
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import { BasicContent } from './BasicContent';
import RichText from './RichText';
import { CalculatorFiberglass } from '../../ProPink/CalculatorFiberglass';
import Container from '../oc-container';

const CMSFiberglassCalculator = ({ ...content }) => {
  const store = ReactOnRails.getStore('Store');

  return (
    <>
      <BasicContent {...content.copy} />
      <Provider store={store}>
        <Container maxWidth="1170">
          <CalculatorFiberglass />
        </Container>
      </Provider>
      <RichText content={content.footnotes} />
    </>
  );
};

export default CMSFiberglassCalculator;
